import { useMutation } from "@tanstack/react-query";

import { createSubscriber } from "@services/subscriber";

export const useCreateSubscriber = (options: Record<string, any> = {}) => {
  return useMutation(createSubscriber, options);
};
